import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AddAssets.css";

function AddAssets({ tokenStorage, setOpenAddProfile, openAddProfile }) {
  const [dropdownData, setDropdownData] = useState([]);
  const [ownerData, setOwnerData] = useState([]);

  const baseAPI = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    Tseed: "",
    product_type: "",
    product_name: "",
    product_brand: "",
    product_config: "",
    product_warranty: "",
    Image: "",
    product_serial_number: "",
    current_owner: "",
    Is_Active: "1",
    date_of_purchase: "",
    date_of_issue: "",
    date_of_return: "",
    password: "",
  });

  useEffect(() => {
    fetchDropdownData();
  }, []);

  // Fetch dropdown data
  const fetchDropdownData = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GetAsset?assetID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setDropdownData(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching dropdown data:", error);
        });
      axios
        .get(
          `${baseAPI}adminget/GETEmployee?employeeID=&desg_id=0&dept_id=0&region_id=0&meal_Preference=&status=&location=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setOwnerData(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching employee data for owners:", error);
        });
    }
  };

  const handleDropdownChange = (e) => {
    setFormData({
      ...formData,
      product_type: e.target.value,
    });
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "Image") {
      const file = files[0];

      if (file) {
        const allowedTypes = [
          "image/jpeg",
          "image/png",
          "image/gif",
          "image/webp",
        ];
        if (!allowedTypes.includes(file.type)) {
          alert("Only JPG, PNG, GIF, and WEBP files are allowed.");
          return;
        }
        getUpdatedImage(file, name);
      }
    } else {
      if (name === "date_of_issue") {
        const dateOfPurchase = new Date(formData.date_of_purchase);
        const dateOfIssue = new Date(value);

        if (dateOfIssue < dateOfPurchase) {
          alert(
            "The date of issue must be greater than or equal to the date of purchase."
          );
          return; // Do not update state
        }
      }

      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  function getUpdatedImage(file, name) {
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imageData = reader.result;
        setFormData({
          ...formData,
          [name]: imageData,
        });
      };

      reader.readAsDataURL(file);
    }

    const formatDate = (dateString) => {
      const options = {
        day: "numeric",
        month: "short",
        year: "numeric",
      };

      const formattedDate = new Date(dateString).toLocaleString(
        "en-US",
        options
      );
      return formattedDate;
    };
  }

  const handleSubmit = async (e) => {
    e.preventDefault();    

    if (formData.current_owner && !formData.date_of_issue) {
      alert("Date of Issue is mandatory when an owner is selected.");
      return; // Prevent submission
  }

    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.post(
          `${baseAPI}adminpost/AddOrUpdateAsset`,         
          formData,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        alert(response.data.message);
        setOpenAddProfile(false);
        tokenStorage();
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <div className="add-assets-container">
      <form className="add-assets-form" onSubmit={(e) => e.preventDefault()}>
        <table className="add-assets-table">
          <thead>
            <tr className="add-assets-table-heading">
              <th className="add-assets-table-header">Product Type</th>
              <th className="add-assets-table-header">Product Name</th>
              <th className="add-assets-table-header">Product Make/Brand</th>
            </tr>
          </thead>
          <tbody>
            <tr className="add-assets-table-row">
              <td className="add-assets-table-cell">
                <select
                  className="add-assets-select-asset"
                  value={formData.product_type}
                  onChange={handleDropdownChange}
                >
                  <option value="">Select a Product</option>
                  {dropdownData.map((item) => (
                    <option key={item.assetTypeID} value={item.assets_type}>
                      {item.assets_type}
                    </option>
                  ))}
                </select>
              </td>

              <td className="add-assets-table-cell">
                <input
                  type="text"
                  name="product_name"
                  className="add-assets-input-brand"
                  value={formData.product_name}
                  onChange={handleInputChange}
                  placeholder="Enter Asset Brand"
                />
              </td>

              <td className="add-assets-table-cell">
                <input
                  type="text"
                  placeholder="Asset Brand"
                  name="product_brand"
                  className="add-assets-input-name"
                  value={formData.product_brand}
                  onChange={handleInputChange}
                />
              </td>
            </tr>

            <tr className="add-assets-table-heading">
              <th className="add-assets-table-header">Product Configuration</th>
              <th className="add-assets-table-header">Product Warranty</th>
              <th className="add-assets-table-header">Image</th>
            </tr>
            <tr className="add-assets-table-row">
              <td className="add-assets-table-cell">
                <input
                  className="add-assets-input-description"
                  name="product_config"
                  value={formData.product_config}
                  onChange={handleInputChange}
                  placeholder="Enter a description"
                />
              </td>

              <td className="add-assets-table-cell">
                <input
                  type="text"
                  name="product_warranty"
                  className="add-assets-input-warranty"
                  value={formData.product_warranty}
                  onChange={handleInputChange}
                  placeholder="Enter Warranty Details"
                />
              </td>

              <td className="add-assets-table-cell">
                <input
                  style={{
                    border: "1px solid #7d7f81",
                    height: "38px",
                    width: "100%",
                    maxWidth: "370px",
                    overflow: "hidden",
                    padding: "5px",
                    boxSizing: "border-box",
                  }}
                  type="file"
                  name="Image"
                  className="add-assets-input-file"
                  onChange={handleInputChange}
                />
              </td>
            </tr>

            <tr className="add-assets-table-heading">
              <th className="add-assets-table-header">Product Serial Number</th>
              <th className="add-assets-table-header">Assign To</th>
              <th className="add-assets-table-header">Current Status</th>
            </tr>
            <tr className="add-assets-table-row">
              <td className="add-assets-table-cell">
                <input
                  type="text"
                  name="product_serial_number"
                  className="add-assets-input-serial-number"
                  value={formData.product_serial_number}
                  onChange={handleInputChange}
                  placeholder="Enter Serial Number"
                />
              </td>
              <td className="add-assets-table-cell">
                <select
                  name="current_owner"
                  value={formData.current_owner}
                  onChange={handleInputChange}
                  className="add-assets-select-owner"
                >
                  <option value="">Select Owner</option>
                  {ownerData.map((owner) => (
                    <option key={owner.ID} value={owner.Name}>
                      {owner.name}
                    </option>
                  ))}
                </select>
              </td>
              <td className="add-assets-table-cell">
                <select
                  name="Is_Active"
                  value={formData.Is_Active}
                  onChange={handleInputChange}
                  className="add-assets-select-status"
                >
                  <option value="1" default>Active</option>
                  <option value="0">Inactive</option>
                </select>
              </td>
            </tr>

            <tr className="add-assets-table-heading">
              <th className="add-assets-table-header">Date of Purchase</th>
              <th className="add-assets-table-header">Date of Issue</th>
              <th className="add-assets-table-header">Date of Return</th>
            </tr>
            <tr className="add-assets-table-row">
              <td className="add-assets-table-cell">
                <input
                  type="date"
                  name="date_of_purchase"
                  className="add-assets-input-date"
                  value={formData.date_of_purchase}
                  onChange={handleInputChange}
                />
              </td>
              <td className="add-assets-table-cell">
                <input
                  type="date"
                  name="date_of_issue"
                  className="add-assets-input-date"
                  value={formData.date_of_issue}
                  onChange={handleInputChange}
                />
              </td>
              <td className="add-assets-table-cell">
                <input
                  type="date"
                  name="date_of_return"
                  className="add-assets-input-date"
                  disabled
                  value={formData.date_of_return}
                  onChange={handleInputChange}
                />
              </td>
            </tr>
            <tr className="add-assets-table-heading">
              <td className="add-assets-table-header">Password</td>
              <td></td>
              <td></td>
            </tr>
            <tr className="add-assets-table-row">
              <td className="add-assets-table-cell">
                <input
                  type="text"
                  name="password"
                  className="add-assets-input-warranty"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Enter Product Password"
                />
              </td>
              <td> </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <hr />

        <div className="add-assets-buttons">
          <button
            type="button"
            style={{
              backgroundColor: "white",
              color: "red",
              border: "none",
              fontWeight: "600 ",
            }}
            onClick={() => {
              setFormData({
                Tseed: "",
                product_type: "",
                product_config: "",
                Is_Active: "",
                accesstoken: "",
                Image: "",
                product_serial_number: "",
                Image_serial_number: "",
                password: "",
                current_owner: "",
                date_of_purchase: "",
                Product_Warranty: "",
                date_of_issue: "",
                date_of_return: "",
                asset_brand: "",
              });
            }}
          >
            Reset
          </button>

          <button
            type="submit"
            className="add-assets-submit-button"
            onClick={handleSubmit}
          >
            Add
          </button>
          <hr />
        </div>
      </form>
    </div>
  );
}

export default AddAssets;
